<template>
  <div class="broadcast-detail-page">
    <div class="broadcast-header">
      <el-button icon="el-icon-arrow-left" circle size="mini" @click="goBack"></el-button>
      <span class="broadcast-header-title">{{ broadcastTitle || "广播详情" }}</span>
    </div>
    <div class="detail-body" v-loading="loading" element-loading-text="加载中...">
      <div v-if="!loading && !broadcast.id" class="empty-tip">广播消息不存在</div>
      <div v-else class="detail-card">
        <div class="detail-top">
          <div class="detail-icon">
            <i class="el-icon-message-solid"></i>
          </div>
          <div>
            <div class="detail-source">广播服务</div>
            <div class="detail-time">{{ formatTime(broadcast.releaseTime) }}</div>
          </div>
        </div>
        <h2 class="detail-title">{{ broadcast.title }}</h2>
        <div class="detail-content" v-html="safeContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPublicMsg } from "../api/publicMsg";

export default {
  name: "BroadcastDetail",
  data() {
    return {
      broadcast: {},
      loading: false
    };
  },
  computed: {
    broadcastTitle() {
      return this.broadcast.title || "";
    },
    safeContent() {
      return this.sanitizeHtml(this.broadcast.content || "");
    }
  },
  mounted() {
    this.loadBroadcastDetail();
  },
  methods: {
    loadBroadcastDetail() {
      const id = this.$route.params.id;
      if (!id) return;
      this.loading = true;
      getPublicMsg(id)
        .then((result) => {
          this.broadcast = result || {};
        })
        .catch(() => {
          this.$message.error("加载广播详情失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push("/home/broadcast");
    },
    formatTime(timeStr) {
      if (!timeStr) return "";
      const date = new Date(timeStr);
      if (Number.isNaN(date.getTime())) return "";
      const pad = (value) => String(value).padStart(2, "0");
      return `${date.getFullYear()}年${pad(date.getMonth() + 1)}月${pad(date.getDate())}日 ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    sanitizeHtml(html) {
      return String(html)
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
        .replace(/\son\w+="[^"]*"/gi, "")
        .replace(/\son\w+='[^']*'/gi, "")
        .replace(/javascript:/gi, "");
    }
  }
};
</script>

<style scoped lang="scss">
.broadcast-detail-page {
  height: 100%;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.broadcast-header {
  height: 50px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
  box-sizing: border-box;
}

.broadcast-header-title {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  box-sizing: border-box;
}

.detail-card {
  max-width: 860px;
  margin: 0 auto;
  padding: 24px 28px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
}

.detail-top {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.detail-icon {
  width: 42px;
  height: 42px;
  margin-right: 12px;
  border-radius: 12px;
  background: #f59e0b;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.detail-source {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.detail-time {
  margin-top: 4px;
  font-size: 12px;
  color: #9ca3af;
}

.detail-title {
  margin: 0 0 18px;
  font-size: 22px;
  line-height: 32px;
  color: #111827;
  letter-spacing: 0;
}

.detail-content {
  font-size: 15px;
  line-height: 1.8;
  color: #374151;
  word-break: break-word;
}

.detail-content::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.empty-tip {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}
</style>
